<template>
  <main class="page">
    <section class="section page__content">
      <div class="welcome-page__inner">
        <div class="welcome-page__logo">
          <img src="/img/svg/logo.svg" alt="Интекс">
        </div>

        <h1 class="title welcome-page__title">Добро пожаловать на портал ИНТЕКС</h1>

        <p class="text welcome-page__text">
          Рады приветствовать Вас в рядах нашей команды производственно-строительного холдинга «ИНТЕКС»!
        </p>
        <p class="text welcome-page__text">
          Ваш труд ценен для всей компании, и мы ждем от вас наилучших результатов!
          Корпоративный портал призван сделать коммуникации в компании быстрее и эффективнее.
        </p>
        <p class="text welcome-page__text">
          Используйте функционал портала для постановки задач, передачи информации и других рабочих процессов.
        </p>
        <p class="text welcome-page__text">
          Помните: задача, поставленная четко и развернуто, приводит к положительному результату, плохо поставленная задача – к дополнительным работам и потере времени.
          Хорошего трудового дня!
        </p>
        <router-link to="/" class="welcome-page__link">Как работать с порталом</router-link>
      </div>
    </section>
  </main>
</template>

<script>

export default {
  name: 'Home',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  .welcome-page {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - #{$header_height});

    &__inner {
      width: 100%;
      max-width: 390px;
      margin: 100px auto 0;

      @media screen and (max-width: $tablet_start) {
        margin-top: 0;
      }
    }

    &__logo {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
    }

    &__title {
      margin-bottom: 20px;
    }

    &__text {
      color: $font_color_second;
      margin-bottom: 20px;
    }

    &__link {
      display: inline-block;
      color: $color_second-light;
      border-bottom: 1px solid currentColor;
      line-height: 1.15;
      transition: .3s;

      &:active {
        color: $color_second-dark;
      }

      &[disabled] {
        color: $color_deactive;
        pointer-events: none;
      }
    }
  }
</style>
